import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useGlobalContext } from "../../component/GlobalContext";
import { HTTP } from "../../api/http-common";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CouponCard from "./../../component/CouponCard"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function VendorDashboard() {
  const { globalUserVar } = useGlobalContext();
  const access_token = localStorage.getItem('access_token');

  const [roleId, setRoleId] = useState("1");
  const [totalCoupons, setTotalCoupons] = useState(0);
  const [totalVendors, setTotalVendors] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [dataSet, setDataSet] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [highestUsedCoupon, setHighestUsedCoupon] = useState(null);
  const [totalMembersUsed, setTotalMembersUsed] = useState(0);


  // Chart data
  const data = {
    labels: coupons.map((coupon) => `${coupon.coupon_code}`), // Add index for ordering
    datasets: [
      {
        label: "Deal Usage",
        data: coupons.map(coupon => coupon.usage_count),
        backgroundColor: coupons.map(coupon =>
          highestUsedCoupon && coupon.id === highestUsedCoupon.id
            ? "rgba(54, 162, 235, 0.6)"  // Highlight highest-used coupon
            : "rgba(54, 162, 235, 0.6)"
        ),
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };


  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: true, text: "Top Used Deals" },
    },
  };

  useEffect(() => {
    if (typeof globalUserVar === "string") {
      const userData = JSON.parse(globalUserVar);
      setRoleId(userData.role_id);
      loadDashboard();
    }
  }, [globalUserVar]);


  const loadDashboard = async () => {
    try {
      const config = {
        headers: { 'Content-Type': 'application/json', 'token': access_token },
      };

      const response = await HTTP.post('vendors/dashboard', {}, config);

      if (response.status === 200) {
        // ✅ Set dashboard counts
        setTotalCoupons(response.data.total_coupons);
        setTotalVendors(response.data.total_vendors);
        setTotalUsers(response.data.total_members);
        setDataSet(response.data.bar_chart_dataset);

        // ✅ Fetch coupons from the dashboard response
        if (response.data.coupons) {
          setCoupons(response.data.coupons);
        }

        // ✅ Set highest-used coupon data
        if (response.data.highest_used_coupon) {
          setHighestUsedCoupon(response.data.highest_used_coupon);
          setTotalMembersUsed(response.data.total_members_used);
        }
      }
    } catch (error) {
      console.error("Error loading dashboard:", error);
    }
  };


  return (
    <div>
      <h4 className='font-semibold text-[40px] text-center py-2 pb-0 mb-0'>Trending Deals</h4>
      {/* <div
          className={`grid gap-4 mt-4 ${
            coupons.length === 1 ? "grid-cols-1 place-items-center" : "grid-cols-1 md:grid-cols-3"
          }`}
        >
          {coupons.map((coupon, index) => (
            index < 3 && ( // Show only first 3 coupons
              <div key={coupon.id}>
                <Link to="/coupons" className="text-sm flex items-center">
                  <h5 className="px-4 py-2 font-semibold">Usage Count:</h5>
                  <span className="text-[#7c3aed] font-semibold">
                    <h2>{coupon.usage_count}</h2>
                  </span>
                </Link>
                <CouponCard coupon={coupon} />
              </div>
            )
          ))}
        </div> */}
      <div className="px-10">
        <div className="flex align-items-center justivy-evenly">
          {coupons.map((coupon, index) => (
            index < 3 && ( // Show only first 3 coupons
              <div className="coupon-card-wrapper" key={coupon.id}>
                <Link to="/coupons" className="text-sm flex items-center">
                  <p className="px-4 py-2 font-semibold">Usage Count:</p>
                  <span className="text-[#7c3aed] font-semibold">
                    <h2>{coupon.usage_count}</h2>
                  </span>
                </Link>
                <CouponCard couponSize="w-[100%]" coupon={coupon} />
              </div>
            )
          ))}
        </div>
      </div>


      <div className="custom-dashboard-container">
        <br />
        {coupons.length > 0 ? (
          <div className="w-full md:w-2/3 mx-auto">
            <Bar data={data} options={options} />
          </div>
        ) : (
          <p className="text-center text-gray-500">No Deals usage data available.</p>
        )}
      </div>
    </div>
  );


}

export default VendorDashboard;
